var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-tooltip"},[_c('div',{staticClass:"c-tooltip-content",on:{"mouseover":function($event){return _vm.showTips($event)},"mouseleave":_vm.closeTips}},[_vm._t("content")],2),(_vm.tipsShow)?_c('div',{staticClass:"c-tooltip-tip",class:_vm.placement,style:(_vm.tipsStyle)},[_vm._t("tip")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }